(() => {
  if (customElements.get('scratch-popup')) return;

  /* ---------- Rubbellos als einziges Rabatt-Pop-up ----------
     Der Split-Test popup-v1 (A Klaviyo, B Rubbellos) ist am 05.10.2026 beendet, B hat gewonnen.
     Jeder Besucher bekommt das Rubbellos, auch ohne Statistik-Einwilligung. Die beiden Klaviyo-Pop-ups
     (R6rEpD mobil, RwpGjX desktop) bleiben immer stumm. Gemessen wird weiter nur mit Einwilligung,
     unter Variante b, damit die Zahlen an die Testreihe anschliessen. ?popup_split=b oeffnet zum Testen. */
  const TEST_ID = 'popup-v1';
  const SPLIT_KEY = 'sniffys-popup-split-v1';
  const SESSION_KEY = 'sniffys-popup-split-session';
  const ASSIGN_KEY = 'sniffys-popup-assign-v1';
  const STATE_KEY = 'sniffys-scratch-popup';
  const KLAVIYO_FORMS = ['R6rEpD', 'RwpGjX'];
  const root = document.documentElement;
  const forced = 'popupSplitForced' in root.dataset;
  /* Seiten ohne Rabatt-Pop-up (snippets/popup-split-head.liquid setzt data-popup-off) */
  const popupOff = 'popupOff' in root.dataset;
  let persisted = false;
  let endpoint = '';

  const store = {
    get(key) {
      try {
        return localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {}
    },
  };

  const consentGiven = () => {
    try {
      return Boolean(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.());
    } catch (e) {
      return false;
    }
  };

  const sessionId = () => {
    try {
      let id = sessionStorage.getItem(SESSION_KEY);
      if (!id) {
        id = crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
        sessionStorage.setItem(SESSION_KEY, id);
      }
      return id;
    } catch (e) {
      return null;
    }
  };

  const track = (event) => {
    if (!persisted || forced || !endpoint) return;
    const body = JSON.stringify({
      test: TEST_ID,
      variant: root.dataset.popupSplit,
      event,
      session: sessionId(),
      page: location.pathname,
      theme: window.Shopify?.theme?.role,
    });
    try {
      if (!navigator.sendBeacon?.(endpoint, new Blob([body], { type: 'text/plain' }))) {
        fetch(endpoint, { method: 'POST', body, keepalive: true, headers: { 'Content-Type': 'text/plain' } });
      }
    } catch (e) {}
  };

  const silenceKlaviyo = () => {
    try {
      const kl = JSON.parse(store.get('klaviyoOnsite') || '{}');
      kl.viewedForms = kl.viewedForms || {};
      kl.viewedForms.modal = kl.viewedForms.modal || {};
      const off = (kl.viewedForms.modal.disabledForms = kl.viewedForms.modal.disabledForms || {});
      const now = Math.floor(Date.now() / 1000);
      KLAVIYO_FORMS.forEach((id) => {
        off[id] = { ...off[id], lastCloseTime: now };
      });
      store.set('klaviyoOnsite', JSON.stringify(kl));
    } catch (e) {}
  };

  /* Variante am Warenkorb, damit sie in der Bestellung landet. Einmal pro Sitzung pruefen,
     weil nach einer Bestellung oder nach Ablauf ein neuer Warenkorb ohne Attribut entsteht. */
  /* Beide Split-Skripte schreiben in denselben Warenkorb, deshalb nacheinander ueber eine gemeinsame Kette */
  const tagCart = (name, value) => {
    const flag = `sniffys-cart-tag:${name}:${value}`;
    try {
      if (sessionStorage.getItem(flag)) return;
    } catch (e) {}
    const run = async () => {
      const routes = window.Shopify?.routes?.root || '/';
      let cart = await fetch(`${routes}cart.js`).then((r) => r.json());
      if (cart.attributes?.[name] !== value) {
        cart = await fetch(`${routes}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { [name]: value } }),
        }).then((r) => r.json());
      }
      if (cart.attributes?.[name] === value) sessionStorage.setItem(flag, '1');
    };
    window.__sniffysCartTags = (window.__sniffysCartTags || Promise.resolve()).then(run).catch(() => {});
  };

  /* Ausloeser fuer beide Varianten, damit A und B gleich oft aufgehen. Es reicht EINE Bedingung:
     Mobil 14 s auf der Seite ODER 35 % gescrollt, Desktop Maus verlaesst die Seite ODER 30 s.
     Die Zeit laeuft ab Seitenaufruf, nicht erst ab der Einwilligung. */
  const onTrigger = ({ mobileDelay = 14, mobileScroll = 35, desktopDelay = 30 } = {}, fire) => {
    const loadedAt = performance.timeOrigin || Date.now();
    const elapsed = () => Date.now() - loadedAt;
    let fired = false;
    let cleanup = () => {};
    const run = () => {
      if (fired) return;
      fired = true;
      cleanup();
      fire();
    };
    if (window.matchMedia('(max-width: 767px)').matches) {
      const depth = mobileScroll / 100;
      const onScroll = () => {
        /* Nur echtes Scrollen zaehlt. Eine noch nicht fertig aufgebaute Seite ohne Scrollhoehe
           loest nicht aus, dafuer ist der Zeit-Ausloeser da. */
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max <= 0 || window.scrollY <= 0) return;
        if (window.scrollY / max >= depth) run();
      };
      const timer = setTimeout(run, Math.max(0, mobileDelay * 1000 - elapsed()));
      window.addEventListener('scroll', onScroll, { passive: true });
      cleanup = () => {
        clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
      };
    } else {
      const onLeave = (e) => {
        if (e.clientY > 0 || e.relatedTarget) return;
        run();
      };
      const timer = setTimeout(run, Math.max(0, desktopDelay * 1000 - elapsed()));
      document.addEventListener('mouseout', onLeave);
      cleanup = () => {
        clearTimeout(timer);
        document.removeEventListener('mouseout', onLeave);
      };
    }
  };

  /* Variante A: die Klaviyo-Formulare stehen auf Exit-Intent und gehen dadurch vor allem am Handy
     kaum auf. Fuer den Test oeffnen wir sie selbst, mit denselben Ausloesern wie das Rubbellos.
     Klaviyos eigene Wiedervorlage greift dabei nicht, deshalb merken wir uns Schliessen und
     Anmeldung hier und halten dieselben 7 Tage Ruhe wie Variante B. */
  const KLAVIYO_STATE_KEY = 'sniffys-klaviyo-popup';
  const klaviyoState = () => {
    try {
      return JSON.parse(store.get(KLAVIYO_STATE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  };
  const saveKlaviyoState = (patch) => store.set(KLAVIYO_STATE_KEY, JSON.stringify({ ...klaviyoState(), ...patch }));
  let klaviyoArmed = false;

  const armKlaviyo = async () => {
    if (klaviyoArmed || root.dataset.popupSplit !== 'a') return;
    klaviyoArmed = true;
    const cooldownDays = Number(document.querySelector('scratch-popup')?.dataset.cooldownDays || 7);
    const { submitted, closedAt } = klaviyoState();
    if (submitted || (closedAt && Date.now() - closedAt < cooldownDays * 86400000)) return;
    try {
      const identified = await Promise.race([
        Promise.resolve(window.klaviyo?.isIdentified?.()),
        new Promise((resolve) => setTimeout(() => resolve(false), 2000)),
      ]);
      if (identified === true) return;
    } catch (e) {}
    const formId = window.matchMedia('(max-width: 767px)').matches ? KLAVIYO_FORMS[0] : KLAVIYO_FORMS[1];
    onTrigger({}, () => {
      try {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      } catch (e) {}
    });
  };

  const assign = () => {
    if (forced || popupOff) return;
    root.dataset.popupSplit = 'b';
    silenceKlaviyo();
    document.querySelector('scratch-popup')?.arm();
    /* Messen nur mit Einwilligung */
    if (!consentGiven()) return;
    if (!persisted) {
      persisted = true;
      store.set(SPLIT_KEY, 'b');
      tagCart('_popup_split', `${TEST_ID}:b`);
    }
    try {
      if (!sessionStorage.getItem(ASSIGN_KEY)) {
        sessionStorage.setItem(ASSIGN_KEY, '1');
        track('popup_assign');
      }
    } catch (e) {}
  };

  /* Variante A messen, Variante B vor einem Klaviyo-Pop-up schuetzen, das schon unterwegs war */
  window.addEventListener('klaviyoForms', (e) => {
    const { type, formId } = e.detail || {};
    if (!KLAVIYO_FORMS.includes(formId)) return;
    if (root.dataset.popupSplit === 'b' || popupOff) {
      if (type === 'open') {
        setTimeout(() => {
          document.querySelector('div[role="dialog"][aria-label="POPUP Form"] button[aria-label]')?.click();
        }, 50);
      }
      return;
    }
    const map = { open: 'popup_view', submit: 'popup_submit', close: 'popup_close' };
    if (type === 'submit') saveKlaviyoState({ submitted: true });
    if (type === 'close') saveKlaviyoState({ closedAt: Date.now() });
    if (map[type]) track(map[type]);
  });

  document.addEventListener('visitorConsentCollected', () => {
    if (!consentGiven()) {
      try {
        localStorage.removeItem(SPLIT_KEY);
      } catch (e) {}
    }
    assign();
  });

  /* Auf die Einwilligungs-API warten (fuer die Messung), nach 10 s aber trotzdem zuteilen,
     damit das Pop-up auch ohne sie aufgeht */
  const whenPrivacyReady = (tries = 0) => {
    if (window.Shopify?.customerPrivacy || tries >= 40) return assign();
    setTimeout(() => whenPrivacyReady(tries + 1), 250);
  };

  /* ---------- Pop-up ---------- */
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const REVEAL_AT = 0.5;
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const buzz = (pattern) => {
    try {
      if (!reducedMotion()) navigator.vibrate?.(pattern);
    } catch (e) {}
  };
  const cssRgb = (el, name, fallback) => {
    const v = getComputedStyle(el).getPropertyValue(name).trim();
    return v ? `rgb(${v.replace(/\s+/g, ' ')})` : fallback;
  };

  /* Partikel fuer Rubbel-Spaene und Konfetti, eine Canvas ueber dem ganzen Dialog */
  class Fx {
    constructor(canvas, host) {
      this.canvas = canvas;
      this.host = host;
      this.ctx = canvas.getContext('2d');
      this.parts = [];
      this.running = false;
    }

    resize() {
      const r = this.host.getBoundingClientRect();
      this.dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.canvas.width = Math.round(r.width * this.dpr);
      this.canvas.height = Math.round(r.height * this.dpr);
      this.rect = r;
    }

    local(x, y) {
      const r = this.host.getBoundingClientRect();
      return { x: (x - r.left) * this.dpr, y: (y - r.top) * this.dpr };
    }

    shavings(clientX, clientY, colors) {
      if (reducedMotion()) return;
      const p = this.local(clientX, clientY);
      for (let i = 0; i < 3; i++) {
        this.parts.push({
          x: p.x,
          y: p.y,
          vx: (Math.random() - 0.5) * 5 * this.dpr,
          vy: (-Math.random() * 3 - 1) * this.dpr,
          g: 0.28 * this.dpr,
          size: (2 + Math.random() * 3) * this.dpr,
          rot: Math.random() * 6,
          vr: (Math.random() - 0.5) * 0.4,
          life: 1,
          decay: 0.025 + Math.random() * 0.02,
          color: colors[(Math.random() * colors.length) | 0],
          shape: 'flake',
        });
      }
      this.start();
    }

    confetti(clientX, clientY, colors) {
      if (reducedMotion()) return;
      const p = this.local(clientX, clientY);
      for (let i = 0; i < 140; i++) {
        const angle = Math.random() * Math.PI * 2;
        const speed = (4 + Math.random() * 11) * this.dpr;
        this.parts.push({
          x: p.x,
          y: p.y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed - 6 * this.dpr,
          g: 0.32 * this.dpr,
          drag: 0.975,
          size: (5 + Math.random() * 6) * this.dpr,
          rot: Math.random() * 6,
          vr: (Math.random() - 0.5) * 0.5,
          life: 1,
          decay: 0.006 + Math.random() * 0.008,
          color: colors[(Math.random() * colors.length) | 0],
          shape: Math.random() < 0.25 ? 'dot' : 'ribbon',
        });
      }
      this.start();
    }

    start() {
      if (this.running) return;
      this.running = true;
      const tick = () => {
        const { ctx, canvas } = this;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.parts = this.parts.filter((q) => q.life > 0 && q.y < canvas.height + 40);
        for (const q of this.parts) {
          if (q.drag) {
            q.vx *= q.drag;
            q.vy *= q.drag;
          }
          q.vy += q.g;
          q.x += q.vx;
          q.y += q.vy;
          q.rot += q.vr;
          q.life -= q.decay;
          ctx.save();
          ctx.globalAlpha = Math.max(0, Math.min(1, q.life * 1.4));
          ctx.translate(q.x, q.y);
          ctx.rotate(q.rot);
          ctx.fillStyle = q.color;
          if (q.shape === 'dot') {
            ctx.beginPath();
            ctx.arc(0, 0, q.size / 2.4, 0, Math.PI * 2);
            ctx.fill();
          } else if (q.shape === 'ribbon') {
            ctx.fillRect(-q.size / 2, -q.size / 5, q.size, q.size / 2.5 * Math.abs(Math.cos(q.rot * 2)) + 1);
          } else {
            ctx.fillRect(-q.size / 2, -q.size / 3, q.size, q.size / 1.6);
          }
          ctx.restore();
        }
        if (this.parts.length) {
          requestAnimationFrame(tick);
        } else {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          this.running = false;
        }
      };
      requestAnimationFrame(tick);
    }
  }

  const METER_LABELS = [
    [0, "Los geht's"],
    [0.08, 'Weiter so'],
    [0.22, 'Da schimmert was'],
    [0.36, 'Gleich hast du es'],
    [REVEAL_AT, 'Freigerubbelt!'],
  ];

  class ScratchPopup extends HTMLElement {
    connectedCallback() {
      endpoint = this.dataset.endpoint || '';
      this.dialog = this.querySelector('.scratch-popup__dialog');
      this.card = this.querySelector('.scratch-popup__card');
      this.canvas = this.querySelector('.scratch-popup__canvas');
      this.fx = new Fx(this.querySelector('.scratch-popup__fx'), this);
      this.form = this.querySelector('form');
      this.error = this.querySelector('[data-error]');
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.meterFill = this.querySelector('.scratch-popup__meter-fill');
      this.meterLabel = this.querySelector('[data-meter-label]');
      this.meterValue = this.querySelector('[data-meter-value]');
      this.count = this.querySelector('[data-count]');
      this.armed = false;
      this.revealed = false;

      this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.querySelector('[data-reveal]').addEventListener('click', () => this.reveal());
      this.form.addEventListener('submit', (e) => this.submit(e));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
        if (e.key === 'Tab') this.trapFocus(e);
      });

      if ('designMode' in this.dataset) {
        this.open();
        return;
      }
      if (popupOff) return;
      if (forced) {
        if (root.dataset.popupSplit === 'b') setTimeout(() => this.open(), 1500);
        return;
      }
      whenPrivacyReady();
    }

    state() {
      try {
        return JSON.parse(store.get(STATE_KEY) || '{}');
      } catch (e) {
        return {};
      }
    }

    saveState(patch) {
      store.set(STATE_KEY, JSON.stringify({ ...this.state(), ...patch }));
    }

    async arm() {
      if (this.armed || root.dataset.popupSplit !== 'b') return;
      this.armed = true;
      const { submitted, closedAt } = this.state();
      const cooldown = Number(this.dataset.cooldownDays || 7) * 86400000;
      if (submitted || (closedAt && Date.now() - closedAt < cooldown)) return;
      /* Bekannte Klaviyo-Profile bekommen kein Pop-up, wie bei den Klaviyo-Formularen. Klaviyo
         antwortet nicht immer (z. B. ohne Einwilligung nicht geladen), deshalb hoechstens 2 s warten. */
      try {
        const identified = await Promise.race([
          Promise.resolve(window.klaviyo?.isIdentified?.()),
          new Promise((resolve) => setTimeout(() => resolve(false), 2000)),
        ]);
        if (identified === true) return;
      } catch (e) {}

      onTrigger(
        {
          mobileDelay: Number(this.dataset.mobileDelay || 14),
          mobileScroll: Number(this.dataset.mobileScroll || 35),
          desktopDelay: Number(this.dataset.desktopDelay || 30),
        },
        () => this.open(),
      );
    }

    /* Shopifys Cookie-Banner liegt auf einer hoeheren Ebene. Solange es sichtbar ist, wuerde das
       Pop-up unsichtbar dahinter aufgehen. Deshalb warten, bis es weg ist. */
    consentBannerVisible() {
      /* Nur ein wirklich sichtbarer Dialog zaehlt: im Bild, mit Hoehe, nicht transparent.
         Leere Container, die nach der Wahl im Seitenaufbau bleiben, blockieren nicht. */
      return [...document.querySelectorAll('.shopify-pc__banner__dialog, #shopify-pc__banner')].some((el) => {
        const style = getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
        const r = el.getBoundingClientRect();
        return r.width > 40 && r.height > 40 && r.bottom > 0 && r.top < window.innerHeight;
      });
    }

    open() {
      if (!this.hidden) return;
      window.__scratchPopupDebug = { lastOpenAttempt: Date.now(), bannerVisible: this.consentBannerVisible() };
      if (this.consentBannerVisible()) {
        clearTimeout(this.waitTimer);
        this.waitTimer = setTimeout(() => this.open(), 700);
        return;
      }
      this.lastFocus = document.activeElement;
      this.hidden = false;
      root.style.overflow = 'hidden';
      this.show('scratch');
      requestAnimationFrame(() => {
        this.paint();
        this.fx.resize();
        this.dialog.focus({ preventScroll: true });
      });
      track('popup_view');
    }

    close() {
      if (this.hidden) return;
      this.hidden = true;
      root.style.overflow = '';
      if (!this.state().submitted) {
        this.saveState({ closedAt: Date.now() });
        track('popup_close');
      }
      this.lastFocus?.focus?.();
    }

    show(name) {
      this.steps.forEach((step) => {
        step.hidden = step.dataset.step !== name;
      });
      requestAnimationFrame(() => this.fx.resize());
      /* Theme-Hervorhebung einzeichnen, sobald der Schritt sichtbar ist */
      const step = this.steps.find((el) => el.dataset.step === name);
      setTimeout(() => step?.querySelectorAll('em.highlighted-text').forEach((em) => em.classList.add('animate')), 250);
    }

    trapFocus(e) {
      const focusable = [...this.dialog.querySelectorAll('button, input, a[href]')].filter((el) => !el.closest('[hidden]'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    /* Rubbelschicht: Sandgelb plus offizieller Streifen, per destination-out wegradieren */
    paint() {
      const rect = this.card.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.canvas.width = Math.round(rect.width * dpr);
      this.canvas.height = Math.round(rect.height * dpr);
      this.ctx = this.canvas.getContext('2d', { willReadFrequently: true });
      const { ctx, canvas } = this;
      ctx.globalCompositeOperation = 'source-over';
      /* Goldfolie wie das Rubbellos auf /pages/freunde: Verlauf, feine Schraffur, Koernung */
      const foil = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
      foil.addColorStop(0, '#b4852b');
      foil.addColorStop(0.22, '#f4d47c');
      foil.addColorStop(0.45, '#d6a443');
      foil.addColorStop(0.62, '#fff0bd');
      foil.addColorStop(0.8, '#d9aa4a');
      foil.addColorStop(1, '#a87a22');
      ctx.fillStyle = foil;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.strokeStyle = 'rgba(255,255,255,0.10)';
      ctx.lineWidth = dpr;
      for (let x = -canvas.height; x < canvas.width; x += 6 * dpr) {
        ctx.beginPath();
        ctx.moveTo(x, canvas.height);
        ctx.lineTo(x + canvas.height, 0);
        ctx.stroke();
      }
      ctx.globalAlpha = 0.07;
      ctx.fillStyle = '#3a2600';
      for (let i = 0; i < (canvas.width * canvas.height) / 700; i++) {
        ctx.fillRect(Math.random() * canvas.width, Math.random() * canvas.height, dpr, dpr);
      }
      ctx.globalAlpha = 1;

      const img = new Image();
      img.onload = () => {
        if (this.revealed) return;
        ctx.globalCompositeOperation = 'source-over';
        const w = canvas.width * 0.84;
        const h = (img.height / img.width) * w;
        ctx.drawImage(img, (canvas.width - w) / 2, (canvas.height - h) / 2, w, h);
      };
      img.src = this.dataset.strip;
      this.progress(0);

      if (this.bound) return;
      this.bound = true;
      const ink = cssRgb(this, '--sp-ink', '#171717');
      const sand = cssRgb(this, '--sp-sand', '#f7d883');
      const flakes = [ink, ink, '#3a3a3a', sand];
      let last = null;
      let measure = 0;
      let lastBuzz = 0;
      const point = (e) => {
        const r = this.canvas.getBoundingClientRect();
        return { x: (e.clientX - r.left) * (this.canvas.width / r.width), y: (e.clientY - r.top) * (this.canvas.height / r.height) };
      };
      const stroke = (p) => {
        const radius = this.canvas.width * 0.075;
        this.ctx.globalCompositeOperation = 'destination-out';
        this.ctx.globalAlpha = 1;
        this.ctx.strokeStyle = '#000';
        this.ctx.lineCap = 'round';
        this.ctx.lineJoin = 'round';
        this.ctx.lineWidth = radius * 2;
        this.ctx.beginPath();
        this.ctx.moveTo((last || p).x, (last || p).y);
        this.ctx.lineTo(p.x + 0.01, p.y);
        this.ctx.stroke();
        last = p;
      };
      const scheduleMeasure = () => {
        if (measure) return;
        measure = requestAnimationFrame(() => {
          measure = 0;
          const ratio = this.cleared();
          this.progress(ratio);
          if (ratio >= REVEAL_AT) this.reveal();
        });
      };
      const handle = (e) => {
        const events = e.getCoalescedEvents ? e.getCoalescedEvents() : [e];
        for (const ev of events.length ? events : [e]) stroke(point(ev));
        this.fx.shavings(e.clientX, e.clientY, flakes);
        const now = performance.now();
        if (now - lastBuzz > 90) {
          buzz(6);
          lastBuzz = now;
        }
        scheduleMeasure();
      };

      this.canvas.addEventListener('pointerdown', (e) => {
        if (this.revealed) return;
        e.preventDefault();
        this.canvas.setPointerCapture(e.pointerId);
        if (!this.classList.contains('is-scratching')) {
          this.classList.add('is-scratching');
          track('popup_scratch');
        }
        last = null;
        handle(e);
      });
      this.canvas.addEventListener('pointermove', (e) => {
        if (this.revealed || !this.canvas.hasPointerCapture(e.pointerId)) return;
        handle(e);
      });
      const end = () => {
        last = null;
        if (!this.revealed) scheduleMeasure();
      };
      this.canvas.addEventListener('pointerup', end);
      this.canvas.addEventListener('pointercancel', end);
    }

    /* Anteil freigerubbelter Flaeche, nur jedes zehnte Pixel pruefen */
    cleared() {
      const { width, height } = this.canvas;
      if (!width || !height) return 0;
      const data = this.ctx.getImageData(0, 0, width, height).data;
      let clear = 0;
      let total = 0;
      for (let i = 3; i < data.length; i += 40) {
        total++;
        if (data[i] < 40) clear++;
      }
      return total ? clear / total : 0;
    }

    progress(ratio) {
      const shown = Math.min(1, ratio / REVEAL_AT);
      this.meterFill?.style.setProperty('--progress', shown.toFixed(3));
      if (this.meterValue) this.meterValue.textContent = `${Math.round(shown * 100)} %`;
      if (this.meterLabel) {
        const label = METER_LABELS.filter(([at]) => ratio >= at).pop();
        if (label && this.meterLabel.textContent !== label[1]) this.meterLabel.textContent = label[1];
      }
    }

    countUp() {
      const target = Number(this.dataset.prizeNumber) || 0;
      if (!this.count || !target || reducedMotion()) return;
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / 650);
        const eased = 1 - Math.pow(1 - t, 3);
        this.count.textContent = String(Math.round(target * eased));
        if (t < 1) requestAnimationFrame(step);
      };
      this.count.textContent = '0';
      requestAnimationFrame(step);
    }

    reveal() {
      if (this.revealed) return;
      this.revealed = true;
      if (!this.classList.contains('is-scratching')) track('popup_scratch');
      this.classList.add('is-scratching', 'is-revealed');
      this.progress(REVEAL_AT);
      this.countUp();
      buzz([18, 40, 28, 40, 60]);

      const r = this.card.getBoundingClientRect();
      const colors = [
        cssRgb(this, '--sp-sand', '#f7d883'),
        cssRgb(this, '--sp-mint', '#a8e8e2'),
        '#ffffff',
        '#ffddbf',
      ];
      this.fx.resize();
      this.fx.confetti(r.left + r.width / 2, r.top + r.height / 2, colors);
      setTimeout(() => this.fx.confetti(r.left + r.width * 0.15, r.top + r.height * 0.3, colors), 180);
      setTimeout(() => this.fx.confetti(r.left + r.width * 0.85, r.top + r.height * 0.3, colors), 320);

      setTimeout(() => {
        this.ctx?.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.show('form');
        this.form.querySelector('input')?.focus({ preventScroll: true });
      }, reducedMotion() ? 0 : 1700);
    }

    async submit(e) {
      e.preventDefault();
      const input = this.form.querySelector('input[type="email"]');
      const email = input.value.trim();
      this.error.hidden = true;
      this.form.classList.remove('is-invalid');
      if (!EMAIL.test(email)) {
        this.error.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.';
        this.error.hidden = false;
        void this.form.offsetWidth;
        this.form.classList.add('is-invalid');
        buzz([30, 30, 30]);
        input.focus();
        return;
      }
      const button = this.form.querySelector('[type="submit"]');
      button.disabled = true;
      try {
        const res = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(this.dataset.companyId)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Rubbellos Pop-up',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                    },
                  },
                },
              },
              relationships: { list: { data: { type: 'list', id: this.dataset.listId } } },
            },
          }),
        });
        if (!res.ok) throw new Error(String(res.status));
        this.saveState({ submitted: true });
        track('popup_submit');
        try {
          window.klaviyo?.identify?.({ email });
        } catch (err) {}
        this.show('done');
        buzz([20, 50, 20]);
        const r = this.dialog.getBoundingClientRect();
        this.fx.confetti(r.left + r.width / 2, r.top + r.height * 0.25, [
          cssRgb(this, '--sp-sand', '#f7d883'),
          cssRgb(this, '--sp-mint', '#a8e8e2'),
          '#ffffff',
        ]);
        this.querySelector('[data-step="done"] button')?.focus({ preventScroll: true });
      } catch (err) {
        this.error.textContent = 'Das hat nicht geklappt. Prüf kurz deine E-Mail-Adresse und versuch es nochmal.';
        this.error.hidden = false;
      } finally {
        button.disabled = false;
      }
    }
  }

  customElements.define('scratch-popup', ScratchPopup);

  /* Seiten ohne Rubbellos-Section: Zuteilung und A-Messung laufen trotzdem */
  if (!document.querySelector('scratch-popup')) whenPrivacyReady();
})();
